<!--  -->
<div>
    <mat-card>
        <!-- <mat-card-header> -->
            <!-- Float right timeline -->
        <div class="mt-2 mb-2">
            <div class="row">
                <div class="col-md-4 text-class text-center">
                    <b> Type : {{questionObj.typeId}} </b>
                </div>
                <div class="col-md-4 text-class text-center ">
                   <b>  Subtype : {{questionObj.subTypeId ||  questionObj.level}} </b>
                </div>
                <div class="col-md-4 text-class text-center">
                   <span> <b> {{questionObj.timeline}} Min(s) </b></span>
                </div>
            </div>
        </div>
        <!-- </mat-card-header> -->
        <mat-divider></mat-divider>
        <mat-card-content>
            <!-- Question with inner html -->
            <div class="row pt-2 pt-md-4">
                <div class="col-12 text-class">
                   <h3 class="mb-0"><b>Question</b></h3>
                </div>
                <div class="col-12">
                    <div *ngIf="questionObj.questionContent" [innerHTML]= "questionObj.questionContent"></div>
                </div>
                <!-- MEDIA Section -->
                <div class="col-12" *ngIf="getQuestionMediaLength()">
                    <img src='{{questionObj.questionMedia[0]}}' class="img-fluid question-media-img" alt="">
                </div>
                <!-- <div class="col-md-6" *ngIf="questionObj.questionMedia.length>0 && questionObj.questionMedia.length==2">
                    <div>
                        <img src='{{questionObj.questionMedia[0]}}'>
                    </div>
                </div>
                <div class="col-md-6" *ngIf="questionObj.questionMedia.length>0 && questionObj.questionMedia.length==2">
                    <div>
                        <img src='{{questionObj.questionMedia[1]}}'>
                    </div>
                </div> -->
                <!-- END OF MEDIA SECTIONS -->
                <!-- OPTIONS SECTION -->
                <div class="col-12 mt-4" *ngIf="checkIfOptionsPresent()">
                    <mat-radio-group aria-label="Select the right asnwer" class="question-card-img-wrap d-flex flex-wrap flex-md-nowrap mb-0">
                        <div *ngFor="let option of questionObj.options">
                            <mat-radio-button value="{{option.id}}">
                                <div *ngIf="checkIfInOption(option,'mediaUrl')" class="mb-4 mx-auto"><img src='{{option.mediaUrl}}' class="img-fluid"></div>
                                <h4 *ngIf="checkIfInOption(option,'text')" class="mb-0 text-center"><b>{{option.text}}</b></h4>
                            </mat-radio-button>
                        </div>
                    </mat-radio-group>
                </div>
            </div>
            <!-- NgFor the options -->
        </mat-card-content>
        <mat-divider></mat-divider>
        <mat-card-footer>
            <!--Submit -->
            <div class="row py-2 py-md-4">
                <div class="col-6 text-center">
                    <button mat-raised-button color="warn" (click)="deleteQuestion(questionObj.questionId,questionObj.typeId)" class="w-50">Delete</button>
                </div>
                <div class="col-6 text-center">
                    <button mat-raised-button color="accent" (click)="editQuestionRoute(questionObj.questionId)" class="w-50">Edit</button>
                </div>
            </div>
        </mat-card-footer>
    </mat-card>  
</div>